import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './HomeScreen.css';

const QUOTES = [
  "Pret a progresser aujourd'hui ?",
  "Chaque minute compte.",
  "Le succes commence maintenant.",
  "Ta concentration, ton super pouvoir.",
  "Un pas de plus vers l'excellence.",
  "Le focus change tout.",
  "Aujourd'hui, tu vas assurer.",
];

function getStats() {
  try {
    const raw = localStorage.getItem('focusup_stats');
    if (raw) return JSON.parse(raw);
  } catch {}
  return { totalSessions: 0, totalMinutes: 0, currentStreak: 0, bestStreak: 0, todayMinutes: 0, todaySessions: 0, lastSessionDate: null };
}

function getUser() {
  try {
    const raw = sessionStorage.getItem('focusup_user');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function HomeScreen() {
  const navigate = useNavigate();
  const [quote] = useState(() => QUOTES[Math.floor(Math.random() * QUOTES.length)]);
  const stats = getStats();
  const [user, setUser] = useState<{ email: string; name: string } | null>(getUser);
  const [signingIn, setSigningIn] = useState(false);

  // Check URL fragment for auth callback
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash.includes('jwt=')) return;
    const params = new URLSearchParams(hash.substring(1));
    const jwt = params.get('jwt');
    const userParam = params.get('user');
    if (jwt && userParam) {
      try {
        const u = JSON.parse(decodeURIComponent(userParam));
        const name = u.displayName || u.email || 'Utilisateur';
        const userObj = { email: u.email ?? '', name };
        setUser(userObj);
        sessionStorage.setItem('focusup_user', JSON.stringify(userObj));
        sessionStorage.setItem('focusup_jwt', jwt);
      } catch {}
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  const signInWithApple = useCallback(async () => {
    setSigningIn(true);
    try {
      if (!(window as any).AppleID) {
        await new Promise<void>((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('Failed to load Apple JS SDK'));
          document.head.appendChild(script);
        });
      }

      const AppleID = (window as any).AppleID;
      const returnUrl = window.location.origin + '/';

      AppleID.auth.init({
        clientId: 'com.alterrego.signin',
        scope: 'email name',
        redirectURI: 'https://api.apps.alterrego.com/auth/apple/callback',
        state: returnUrl,
        usePopup: false,
      });

      AppleID.auth.signIn();
    } catch (err: any) {
      alert('Erreur: ' + (err?.message ?? err));
      setSigningIn(false);
    }
  }, []);

  const signOut = useCallback(() => {
    setUser(null);
    sessionStorage.removeItem('focusup_user');
    sessionStorage.removeItem('focusup_jwt');
  }, []);

  return (
    <div className="fu-home">
      {/* User / Login */}
      <div className="fu-user-bar">
        {user ? (
          <button className="fu-user-pill" onClick={() => navigate('/account')}>
            <span className="fu-user-avatar">{user.name.charAt(0).toUpperCase()}</span>
            <span className="fu-user-name">{user.name}</span>
          </button>
        ) : (
          <button className="fu-login-btn" onClick={signInWithApple} disabled={signingIn}>
             Se connecter
          </button>
        )}
      </div>

      {/* Logo */}
      <div className="fu-logo-block">
        <div className="fu-logo-icon">⚡</div>
        <h1 className="fu-logo-text">FocusUp</h1>
      </div>

      {/* Quote */}
      <p className="fu-quote">{user ? `Salut ${user.name.split(' ')[0]} ! ${quote}` : quote}</p>

      {/* Stats cards */}
      <div className="fu-stats-row">
        <div className="fu-stat-card">
          <span className="fu-stat-value">{stats.currentStreak > 0 ? `${stats.currentStreak} 🔥` : '0'}</span>
          <span className="fu-stat-label">Streak</span>
        </div>
        <div className="fu-stat-card">
          <span className="fu-stat-value">{stats.todayMinutes}'</span>
          <span className="fu-stat-label">Aujourd'hui</span>
        </div>
        <div className="fu-stat-card">
          <span className="fu-stat-value">{stats.totalSessions}</span>
          <span className="fu-stat-label">Sessions</span>
        </div>
      </div>

      {/* CTA */}
      <button className="fu-cta" onClick={() => navigate('/focus')}>
        <span className="fu-cta-icon">▶</span>
        Commencer une session
      </button>

      {/* Bottom nav */}
      <div className="fu-bottom-hint" onClick={() => navigate('/stats')}>
        Voir mes statistiques
      </div>
    </div>
  );
}
